import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider
} from "@material-ui/core";
import Axios from "axios";
import { useFormik } from "formik";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import * as yup from "yup";
import ActionButton from "../../../../modules/CustomizeComponent/ActionButton";

async function asyncForEach(array, callback){
    for (let index = 0; index < array.length; index++){
        await callback(array[index], index, array);
    }
}

export function DocumentSectionRenameFile(props){
    const {client_case_id, row}         = props.passedProps;
    const [open, setOpen]               = useState(false);
    const [loading, setLoading]         = useState(false);
    const [disable, setDisable]         = useState(false);
    const {defaultFolders, setFolders}  = props.passedProps;
    const {isMyDocument}                = props.passedProps;
    const {type}                        = props.passedProps;
    const {sectionId}                   = props.passedProps;
    const {parentId}                    = props.passedProps;
    const allFolders                    = [];

    const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };

    const validationSchema = yup.object({
        name: yup.string()
        .min(1),
    });

    const onSubmit = async (values) => {
        const { ...data } = values;
        setLoading(true);
        setDisable(true);
        if(parentId === undefined || parentId === 0){
            await Axios.put(`api/file/rename/${row.id}`, data)
            .then((res=>{
                if(res.status === 200){
                    setLoading(false);
                    setDisable(false);
                    setOpen(false);
                    setFolders(res.data.data);
                }
            }));
        }else{
            const getFoldersData = {
                client_case_id:client_case_id,
                Parent:parentId,
            };
            await Axios.post(`api/file/getFolders/${client_case_id}`, getFoldersData)
            .then(async(res)=>{
                await asyncForEach(res.data.data, async(folder) =>{
                    allFolders.push(folder)
                });
            });

            await Axios.put(`api/file/rename/${row.id}`, data)
            .then(async(res)=>{
                if(res.status === 200){
                    setLoading(false);
                    setDisable(false);
                    setOpen(false);
                    await asyncForEach(res.data.data, async(file) =>{
                        allFolders.push(file)
                    });
                }
            });
            setFolders(allFolders);
        }
    };

    const formik = useFormik({
        initialValues: {
            client_case_id: client_case_id,
            source:row.source,
            source_id:row.source_id,
            file_path:row.file_path,
            size:row.size,
            type:row.type,
            isActive:row.isActive,
            uploaded_by:row.uploaded_by,
        },
        validateOnBlur: true,
        onSubmit,
        validationSchema: validationSchema,
    });
    

    return(
        <>
            <span className="navi-text" onClick={handleClickOpen}>
                Rename 
            </span>
            <Dialog
                fullWidth={true}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className="mtb-10">{"File Rename"}</DialogTitle>
                <Divider className="mb-10"/>
                <DialogContent>
                <DialogContentText>
                    <div className="login-form login-signin" id="kt_login_signin_form">
                    {/*begin::Form*/}
                    <form
                        onSubmit={formik.handleSubmit}
                        className="form fv-plugins-bootstrap fv-plugins-framework"
                    >
                        <div className="form-group fv-plugins-icon-container">
                        <Form.Label>New File Name</Form.Label>
                        <input
                            type="text"
                            className={`form-control form-control-solid h-auto py-5 px-6 `}
                            name="name"
                            onChange={formik.handleChange}
                            onblur={formik.handleBlur}
                            defaultValue={row.name ? row.name : null}
                        />

                        <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                            {formik.errors.name
                                ? "Please Input Name"
                                : null}
                            </div>
                        </div>
                        </div>

                        <Divider className="form-bottom-divider"/>
                        <DialogActions className="d-flex justify-content-start">
                        
                        <ActionButton
                            id="kt_login_signin_submit"
                            type="submit"
                            disabled={disable}
                            className={`btn custom-green-button font-weight-bold px-9 py-4 my-3`}
                        >
                            <span>Submit</span>
                            {loading && (
                            <span className="ml-3 spinner spinner-white"></span>
                            )}
                        </ActionButton>

                        <Button
                            onClick={handleClose}
                            className={`btn btn-secondary custom-cancel-button font-weight-bold px-9 py-4 my-3`}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        </DialogActions>
                    </form>

                    {/*end::Form*/}
                    </div>
                </DialogContentText>
                </DialogContent>
            </Dialog>
        </>
    )
}
export default DocumentSectionRenameFile